export const DEFAULT_CONFIG = {
    pingInterval: 20000,         // 20 seconds
    inactivityThreshold: 90000, // 1.5 minutes
    initialDelay: 0,         // 20 seconds
    activityEvents: ['mousedown', 'keydown', 'touchstart', 'mousemove'],
  };